const useSellerControlRoomDispatcher = (key) => {
  const dispatchEvent = (data = {}, keyOverride = '') => {
    window.dispatchEvent(
      new CustomEvent('scr-event-in-remote', {
        detail: {
          key: keyOverride || key,
          payload: {
            ...data,
          },
        },
      }),
    );
  };

  return {
    dispatchEvent,
  };
};

export default useSellerControlRoomDispatcher;
